import moment from "moment";
import { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { useUpdateEffect } from "react-use";
import { useRecoilState } from "recoil";
import { getLecture } from "../../api";
import LectureView from "../../components/lecture/LectureView";
import {
  lectureCurriculumState,
  lectureDateState,
  lectureHostState,
  lectureInfoState,
  lecturePlaceState,
  // lectureReportState,
  lectureTitleState,
} from "../../states/atoms/lectureState";
const LectureViewPage = () => {
  const { lecture_id } = useParams();

  const [title, setTitle] = useRecoilState(lectureTitleState);
  const [date, setDate] = useRecoilState(lectureDateState);
  const [place, setPlace] = useRecoilState(lecturePlaceState);
  const [host, setHost] = useRecoilState(lectureHostState);
  const [info, setInfo] = useRecoilState(lectureInfoState);
  const [curriculum, setCurriculum] = useRecoilState(lectureCurriculumState);
  // const [report, setReport] = useRecoilState(lectureReportState);
  const [error, setError] = useState(false);

  const { status, data } = useQuery({
    queryKey: ["lecture/get/item", lecture_id],
    queryFn: () => getLecture({ lecture_id }),
  });

  useUpdateEffect(() => {
    if (status === "success" && !lecture_id) {
      setError("해당 강의 정보를 조회할 수 없습니다.");
    }
    if (status === "success" && lecture_id && data.result) {
      const [tmp] = data.data;
      setError(false);
      setTitle(tmp.title);
      const { start_date, end_date } = tmp;
      const sDate = new moment(start_date);
      const eDate = new moment(end_date);
      setDate([sDate, eDate]);
      setPlace(tmp.place || "");
      setHost(tmp.host || "");
      setInfo(tmp.info || []);
      // setReport(tmp.report || []);
      setCurriculum(tmp.curriculum || []);
    }
  }, [status]);

  return (
    <section className="min-h-screen overflow-y-auto md:mt-4">
      <div className="w-full mx-auto shadow-md overflow-hidden md:rounded-lg md:w-9/12">
        <LectureView {...{ title, date, place, info, curriculum, host }} />
        {error && <div>{error}</div>}
      </div>
    </section>
  );
};

export default LectureViewPage;
